(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zbyvex-collection-rail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('[data-zbv-scroll]');
    if (!button) return;
    const rail = document.getElementById(button.getAttribute('aria-controls'));
    if (!rail) return;
    const card = rail.querySelector('.zbv-collections__card');
    const distance = card ? card.getBoundingClientRect().width + 18 : 300;
    rail.scrollBy({left: button.dataset.zbvScroll === 'next' ? distance : -distance, behavior: 'smooth'});
  });

  } catch(e) { console.error(e); }
})();
})();
